// menu category slugs
export const MEAL_KITS_SLUG = 'meal-kits';
export const EASY_MEAL_KITS_SLUG = 'easy-prep-kits';
export const HEAT_AND_EAT_SLUG = 'heat-and-eat';

// menu category for meal
export const PROTEIN = 'protein';

// serving variants
export const CONTAINER = 'container';
export const MEAL_KIT = 'meal kit';
export const SERVING = 'serving';
export const SERVINGS = 'servings';

export const STANDARD_AS_PACKAGED_ACCESSIBILITY_LABEL =
  'Nutritional values for uncooked ingredients';

export const getNutritionFactInfoLegend = singleColumn => {
  return [
    {
      groupTitle: 'fat',
      fat: 'Total Fat',
      saturatedFat: 'Saturated Fat',
      transFat: 'Trans Fat',
    },
    {
      groupTitle: 'cholesterol',
      cholesterol: 'Cholesterol',
    },
    {
      groupTitle: 'sodium',
      sodium: 'Sodium',
    },
    {
      groupTitle: 'carbohydrates',
      carbohydrates: `Total Carb${singleColumn ? 'ohydrate' : '.'}`,
      dietaryFiber: 'Dietary Fiber',
      sugar: 'Total Sugars',
      addedSugars: 'Incl. Added Sugars',
    },
    {
      groupTitle: 'protein',
      protein: 'Protein',
    },
  ];
};

export const NO_PERCENT_DATA_REQUIRED = ['protein', 'sugar', 'transFat'];

export const VITAMIN_INFO_LEGEND = [
  { vitaminD: 'Vitamin D' },
  { calcium: 'Calcium' },
  { iron: 'Iron' },
  { potassium: 'Potassium' },
];

export const ADDED_SUGARS = 'addedSugars';

export const FAT_CALORIES_PER_GRAM = 9;
export const PROTEIN_CALORIES_PER_GRAM = 4;
export const CARB_CALORIES_PER_GRAM = 4;

export const getStandardNutritionDetails = meal => {
  const {
    calories,
    carbsFormatted,
    fatFormatted,
    netCarbsFormatted,
    proteinFormatted,
    sodiumFormatted,
  } = meal || {};

  return [
    {
      label: 'Calories',
      value: calories,
    },
    {
      label: 'Carbohydrates',
      smallBreakpointLabel: 'Carbs',
      value: carbsFormatted,
    },
    {
      label: 'Net Carbs',
      value: netCarbsFormatted,
    },
    {
      label: 'Fat',
      value: fatFormatted,
    },
    {
      label: 'Protein',
      value: proteinFormatted,
    },
    {
      label: 'Sodium',
      value: sodiumFormatted,
    },
  ];
};

export const getTempoNutritionDiagramDetails = meal => {
  const { carbs, carbsFormatted, fat, fatFormatted, protein, proteinFormatted } = meal || {};

  return [
    {
      label: 'Protein',
      value: proteinFormatted,
      infoColor: 'bg-tempo-blue-90',
      totalCalories: protein * PROTEIN_CALORIES_PER_GRAM,
    },
    {
      label: 'Total Carbs',
      value: carbsFormatted,
      infoColor: 'bg-tempo-yellow-100',
      totalCalories: carbs * CARB_CALORIES_PER_GRAM,
    },
    {
      label: 'Fat',
      value: fatFormatted,
      infoColor: 'bg-tempo-pink-100',
      totalCalories: fat * FAT_CALORIES_PER_GRAM,
    },
  ];
};

export const getTempoNutritionLineDetails = meal => {
  const { netCarbsFormatted, sodiumFormatted } = meal || {};

  return [
    {
      label: 'Net Carbs',
      value: netCarbsFormatted,
    },
    {
      label: 'Sodium',
      value: sodiumFormatted,
    },
  ];
};
